import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '@core/services';
import { ToastService } from '@core/services/toast.service';

/**
 * Functional interceptor to handle server errors in HTTP requests.
 */
export const serverErrorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const toastService = inject(ToastService);
  const ignoreUrls = ['/login', '/logout'];

  /** Check if Session Storage have Ignore Error Intercept. */
  const ignoreErrorIntercept = sessionStorage.getItem('ignoreErrorIntercept');
  const isIgnoreUrl = ignoreUrls.some((keyword) => req.url.includes(keyword));

  if (ignoreErrorIntercept || isIgnoreUrl) return next(req);

  return next(req).pipe(
    catchError((err) => {
      if (!(err instanceof HttpErrorResponse)) return throwError(() => err);

      const errorStatus = err?.status || 0;
      if (errorStatus === 401) {
        toastService.onGetError('Unauthorized!');
        return throwError(() => err);
      } else if (errorStatus === 403) {
        toastService.onGetError('You do not have permission to perform this action.');
        return throwError(() => err);
      } else if (errorStatus >= 500) {
        toastService.onGetError('Services not available. Please try again later.');
        return throwError(() => err);
      } else {
        return throwError(() => err);
      }
    }),
  );
};
